<template>
  <page-header :breadcrumRoutes="routes" title="Modificación individual">
    <template #tags>
      <tags :stateId="ticketStateId" />
      <tags color="processing">ID: {{ modificationId }}</tags>
    </template>

    <template #buttons v-if="userRole != 'rrhh'">
      <a-button
        @click="openCancelModal"
        :loading="loading"
        :disabled="loading"
        v-if="ticketStateId == 2 || ticketStateId == 8 || ticketStateId == 1"
      >
        Cancelar
      </a-button>
      <a-button
        class="ml-2"
        @click="openExecuteModal"
        v-if="ticketStateId == 8"
        :loading="loading"
        :disabled="loading"
        type="primary"
      >
        Ejecutar
      </a-button>
    </template>
  </page-header>

  <stepper
    ticketType="modificacion"
    :state="finalState"
    :stateDates="finalDates"
    ref="stepperRef"
  />

  <a-card class="mb-3">
    <a-row :gutter="[16, 0]">
      <a-col :xs="24" :md="12">
        <a-row class="mb-4">
          <a-col :span="24">
            <div>
              <datos-ticket
                :data="dataToTable"
                title="Datos corporativos"
                :loadTicket="loadTicket"
              />

              <mensaje-aseguradora
                class="mt-3"
                :message="insuranceMessage"
                v-if="userRole != 'rrhh'"
              />
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :xs="24" :md="12">
        <a-row class="mb-4">
          <a-col :xs="24" :md="24">
            <div>
              <records
                title="Historial"
                :data="orderedRecords"
                v-if="userRole != 'rrhh'"
                :loadingHistory="loadingHistory"
              />

              <attached-documents
                v-if="userRole != 'rrhh' && ticketOptionalFiles.length > 0"
                class="mt-3"
                title="Archivos opcionales"
                :data="ticketOptionalFiles"
                :loading="loadingOptionalFiles"
              />

              <comments
                class="mt-3"
                :comments="commentsOrdered"
                :idToTicket="modificationId"
                @new_comment="getNewCommment"
                v-if="userRole != 'rrhh'"
              />
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { reactive, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import openNotificationWithIcon from '@/utils/notifications';
import { createVNode } from 'vue';
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Stepper from '@/components/tickets/stepper.vue';
import DatosTicket from '@/components/tickets/ticket-data.vue';
import Comments from '@/components/tickets/comments.vue';
import Records from '@/components/tickets/records.vue';
import AttachedDocuments from '@/components/tickets/attached-documents.vue';
import MensajeAseguradora from '@/components/tickets/insurer-message.vue';
import parseDate from '@/utils/dateFormatter';
import {
  CANCEL_MODIFICATION_INDIVIDUAL,
  GET_LOGGED_USER,
  FETCH_TICKET_ID,
  FETCH_TICKET_COMMENTS_ID,
  FETCH_RECORD_FILE_TICKET,
  FETCH_USER_BY_ID,
  POST_EXECUTE_MODIFICATION_INDIVIDUAL,
  FETCH_TICKET_OPTIONAL_FILES,
  GET_TICKET_OPTIONAL_FILES
} from '@/store/types';
import PageHeader from '@/components/page-header.vue';
import Tags from '@/components/tags.vue';
import rutHelper from '@/utils/Ruts';

export default {
  name: 'DetalleModificacion',
  components: {
    stepper: Stepper,
    'datos-ticket': DatosTicket,
    Comments,
    records: Records,
    'mensaje-aseguradora': MensajeAseguradora,
    'attached-documents': AttachedDocuments,
    'page-header': PageHeader,
    tags: Tags
  },
  setup() {
    // * VUEX
    const store = useStore();
    const router = useRouter();
    const userRole = store.getters[GET_LOGGED_USER].roleName;
    const finishAlta = ref(false);
    const loadTicket = ref(false);
    const loadingHistory = ref(false);

    // *  Vue router
    const route = useRoute();
    const modificationId = route.params.id;

    const routes = [
      {
        path: '/modificaciones',
        breadcrumbName: 'Modificaciones'
      },
      {
        path: '/modificaciones',
        breadcrumbName: 'Individual'
      },
      {
        breadcrumbName: `#${modificationId}`
      }
    ];

    // // * Ordenar data
    // const parseArrayToString = (values) => {
    //   let final_string = '';

    //   for (let i = 0; i < values.length; i+=1) {
    //     const element = values[i];
    //     let digit = '';

    //     if (i != values.length - 1) {
    //       digit = ',';
    //     }

    //     final_string = final_string + element + digit;
    //   }

    //   return final_string;
    // };

    const getBroker = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };

    // * Ticket
    const ticket = reactive({
      employee: '',
      company: '',
      insurance: '',
      endDate: '',
      messageInsurance: ''
    });
    // const router = useRouter();
    const getTicketData = async (id) => {
      loadTicket.value = true;
      try {
        // Metodo para obtener data y llenar el ticket
        const ticketResponse = await store
          .dispatch(FETCH_TICKET_ID, id)
          .catch(() => router.push({ name: 'Missing' }));
        if (!ticketResponse?.data) {
          loadTicket.value = false;
          return;
        }
        const ticketData = ticketResponse.data;

        // if(ticket.type.id !=3 ){
        //   return router.push({name:'Missing'});
        // }
        ticket.employee = ticketData.employee;
        ticket.emailTicket = ticketData.emailTicket;
        ticket.company = ticketData.company;
        ticket.insurance = ticketData.insuranceCompany.businessName;
        ticket.endDate = parseDate(ticketData.endDate).substring(0, 10);
        loadTicket.value = false;

        const valueToRecords = ticketData.states;
        fillRecordsWithStates(valueToRecords);
        loadTicket.value = false;
      } catch (error) {
        loadTicket.value = false;
        console.log('error', error);
      }
    };

    const ticketLastStateId = computed(() => {
      return ticket.value.states != undefined
        ? ticket.value.states[
            ticket.value.states.length - 1
          ].state.id.toString()
        : '1'; //
    });

    const ticketOptionalFiles = ref([]);
    const loadingOptionalFiles = ref(false);

    const getTicketOptionalFiles = async () => {
      loadingOptionalFiles.value = true;
      try {
        if (userRole != 'rrhh') {
          await store.dispatch(FETCH_TICKET_OPTIONAL_FILES, modificationId);
        }
        ticketOptionalFiles.value = await store.getters[
          GET_TICKET_OPTIONAL_FILES
        ];
        loadingOptionalFiles.value = false;
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al cargar archivos opcionales del Ticket ${modificationId}. ${error}`
        );
        loadingOptionalFiles.value = false;
      }
    };

    // * Comentarios
    const comments = ref([]);
    const getCommentsFromTicket = async (id) => {
      // Metodo para obtener data y llenar los comentarios

      comments.value.length = 0;
      const commentsResponse = await store.dispatch(
        FETCH_TICKET_COMMENTS_ID,
        id
      );

      for (let i = 0; i < commentsResponse.data.length; i += 1) {
        const element = commentsResponse.data[i];
        const brokerName = await getBroker(element.brokerId);
        element.brokerName = brokerName;
        comments.value.push(element);
      }

      fillRecordsWithComents(comments.value);
    };

    const getNewCommment = async (value) => {
      const { brokerId } = value;
      const brokerName = await getBroker(brokerId);

      comments.value.push({
        message: value.title,
        createdAt: value.description,
        brokerName
      });

      records.push({
        title: 'Nuevo comentario',
        description: value.description
      });
    };

    const commentsOrdered = computed(() => {
      const rows = [];

      for (let i = 0; i < comments.value.length; i += 1) {
        const element = comments.value[i];
        const finishDate = new Date(element.createdAt);
        rows.push({
          description: finishDate,
          title: element.message,
          author: element.brokerName
        });
      }

      rows.sort(function (a, b) {
        return a.description - b.description;
      });

      for (let i = 0; i < rows.length; i += 1) {
        const element = rows[i];
        const fecha = parseDate(element.description);
        rows[i].description = fecha;
      }

      return rows;
    });

    // * Archivos
    const fileRecords = ref([]);
    const getFilesRecordsFromTicket = async (id) => {
      // Metodo para obtener data del registro de los archivos enviados por ticket

      fileRecords.value.length = 0;
      const fileRecordsResponse = await store.dispatch(
        FETCH_RECORD_FILE_TICKET,
        id
      );
      for (let i = 0; i < fileRecordsResponse.length; i += 1) {
        const element = fileRecordsResponse[i];
        fileRecords.value.push(element);
      }

      fillRecordsWithFilesHistory(fileRecords.value);
    };

    // * Stepper
    const finalState = ref('');
    const finalDates = ref({});
    const stepperRef = ref('null');
    const cancel_ticket = ref(false);
    const headerStateData = reactive({
      text: '',
      color: '',
      cancel_disabled: false,
      revisado_disabled: false,
      show_buttons: true
    });

    const getStateType = (state) => {
      // Lo transformo en un texto que el stepper lo sepa interpretar, ya que los nombres de los estados
      // Estan en cambio aun, los estados en el stepper siempre van a estar igual, pero no aca
      // la regla es la siguiente

      switch (state) {
        case 'Creado': // Asi viene desde el backend
          return 'creado'; // Asi es como lo toma el stepper y lo marca en su lugar
        case 'En corredora':
          return 'revision_bewell';
        case 'En aseguradora':
          return 'revision_aseguradora';
        case 'Ejecutado':
          return 'ejecutado';
        case 'Cancelado':
          return 'cancelado';
      }
    };

    const cancelStep = () => {
      // Metodo para cancelar el stepper en un cierto paso
      stepperRef.value.cancelStep();
    };
    const finishStep = () => {
      stepperRef.value.finishStep();
    };
    const ticketStateId = ref('');
    const recordsSteps = reactive([]);

    const stepperData = async (id) => {
      // Data para el stepper de manera reactiva

      // 1.- Obtengo data para el ticket
      const ticketResponse = await store
        .dispatch(FETCH_TICKET_ID, id)
        .catch((e) => e.response);
      const ticketData = ticketResponse.data;

      recordsSteps.length = 0;
      for (let i = 0; i < ticketData.states.length; i += 1) {
        const element = ticketData.states[i];
        recordsSteps.push({
          title: element.state.tag,
          description: element.createdAt
        });
      }

      ticketStateId.value =
        ticketData.states[ticketData.states.length - 1].state.id;
      // 2.- Primero obtengo el ultimo estado del cual esta el ticket, obviamente este puede cambiar
      const lastTicketState = {};
      lastTicketState.value = ticketData.states.sort((a, b) => {
        return b.id - a.id;
      })[0].state.tag;

      // 3.- Transformo el ultimo estado en un texto que pueda interpretar el stepper
      let step = getStateType(lastTicketState.value);

      // 4.- En caso de que el paso quede en cancelado, tengo que obtener el penultimo estado
      // que estubo correcto para pasarle a esta propiedad el cancelado para que se muestre
      // con una X en el paso, asi es como lo toma Ant Desing
      if (step === 'cancelado') {
        // Obtengo entonces el penultimo estado
        const lastBefore = ticketData.states.sort((a, b) => {
          return b.id - a.id;
        })[1].state.tag;
        step = getStateType(lastBefore);
        cancelStep();
      }
      if (step == 'ejecutado') {
        finishStep();
      }

      finalState.value = step;

      // 5.- Tomo los estados ordenados por fecha, despues eliminare los siguientes si es que un estado
      // se devolvio al anterior y hay más estados delante del ultimo estado donde quedo
      /*
            (X)            (((X)))                       (X)               ()
                      [este es el ultimo
                        estado ya que
                        se devolvio
                        por alguna razon]
                                              [Este deberia de
                                              eliminarse de la
                                              lista de estados
                                              para no mostrarlo
                                              en el stepper]
          CREADO   EN REVISION BEWELL   EN REVISION ASEGURADORA   EJECUTADO
      */

      const sortedDates = ticketData.states.sort(function (a, b) {
        return a.id - b.id;
      });

      const finalObj = {};
      for (let i = 0; i < sortedDates.length; i += 1) {
        const element = sortedDates[i];
        const stateName = getStateType(element.state.tag);
        finalObj[stateName] = element.createdAt;
      }

      // 6.- Elimino estados que quedaron por delante del ultimo estado como explique arriba
      // Con el ultimo estado del ticket, valido si hay estados más adelantes los cuales deba eliminar

      switch (finalState.value) {
        case 'creado':
          delete finalObj['revision_bewell'];
          delete finalObj['revision_aseguradora'];
          delete finalObj['ejecutado'];
          break;
        case 'revision_bewell':
          delete finalObj['revision_aseguradora'];
          delete finalObj['ejecutado'];
          break;
        case 'revision_aseguradora':
          delete finalObj['ejecutado'];
          break;
      }

      // 7.- En caso de que el ultimo estado este en cancelado, voy a dejar el penultimo estado en marcado
      // Para que se marque la x ahi
      // Voy a preguntar cual es el ultimo estado nuevamente
      const last = ticketData.states.sort((a, b) => {
        return b.id - a.id;
      })[0].state.tag;

      // 8.- Paso data para el page-header
      // Si el ultimo estado esta en 'En revision bewell' osea 'revision_bewell', podemos darle al boton de revisado y de cancelar
      // el unico estado que puedo cancelar y revisar el ticket es en 'Revision aseguradora'

      headerStateData.cancel_disabled = true;
      headerStateData.revisado_disabled = true;
      headerStateData.show_buttons = false;

      switch (last) {
        case 'Creado':
          finishAlta.value = true;
          headerStateData.text = 'Creado';
          headerStateData.color = 'blue';
          break;
        case 'En aseguradora':
          headerStateData.text = 'En revisión aseguradora';
          headerStateData.color = 'gold';
          finishAlta.value = true;
          headerStateData.show_buttons = true;
          break;
        case 'Ejecutado':
          finishAlta.value = false;
          headerStateData.text = 'Ejecutado';
          headerStateData.color = 'green';
          break;
        case 'Cancelado':
          finishAlta.value = false;
          headerStateData.text = 'Cancelado';
          headerStateData.color = 'red';
      }

      if (last === 'Cancelado') {
        // Llamo al metodo que cancela el estado
        cancelStep();
      }

      if (last === 'Ejecutado') {
        finishStep();
        // Llamo al metodo que cancela el estado
      }

      // Si el ultimo estado del ticket fue cancelado, la fecha de este cancelado, se la paso al penultimo estado
      // asi para que se muestre en el penultimo estado que se cancelo con su fecha correspondiente

      const keys_states = Object.keys(finalObj);
      if (last === 'Cancelado') {
        finalObj[keys_states[keys_states.length - 2]] =
          finalObj[keys_states[keys_states.length - 1]];
        delete finalObj['cancelado'];
      }

      // Formateo las fechas
      keys_states.forEach((element) => {
        finalObj[element] = parseDate(finalObj[element]);
      });

      finalDates.value = finalObj;
      if (headerStateData.text == 'cancelado') {
        cancel_ticket.value = false;
      }
      if (headerStateData.text == 'Creado') {
        cancel_ticket.value = true;
      }
    };

    // * Historial
    const records = reactive([]);

    // Llenar el historial con estados del ticket
    const fillRecordsWithStates = (data) => {
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        records.push({
          title: element.state.tag,
          description: element.createdAt
        });
      }
    };

    // Llenar el historial con Comentarios
    const fillRecordsWithComents = (data) => {
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        records.push({
          title: 'Nuevo comentario',
          description: element.createdAt
        });
      }
    };

    // Llenar el historial con el historial de archivos enviados
    const fillRecordsWithFilesHistory = (data) => {
      for (let i = 0; i < data.length; i += 1) {
        const element = data[i];
        records.push({
          title: 'Documento enviado',
          description: element.createdAt
        });
      }
    };
    // const formatDate = (date) => {
    //   const year    = date.getFullYear();
    //   let month   = date.getMonth()+1;
    //   let day     = date.getDate();
    //   let hour    = date.getHours();
    //   let minute  = date.getMinutes();
    //   let second  = date.getSeconds();
    //   if(month.toString().length == 1) {
    //     month = `0${month}`;
    //   }
    //   if(day.toString().length == 1) {
    //     day = `0${day}`;
    //   }
    //   if(hour.toString().length == 1) {
    //     hour = `0${hour}`;
    //   }
    //   if(minute.toString().length == 1) {
    //     minute = `0${minute}`;
    //   }
    //   if(second.toString().length == 1) {
    //     second = `0${second}`;
    //   }
    //   const dateTime = `${year}/${month}/${day} ${hour}:${minute}:${second}`;
    //   return dateTime;
    // };

    const orderedRecords = computed(() => {
      loadingHistory.value = true;
      const rows = [];
      const records = [recordsSteps];

      records.forEach((element) => {
        for (let i = 0; i < element.length; i += 1) {
          const el = element[i];
          if (el.title == 'Ejecutado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'finish'
            });
          } else if (el.title == 'Cancelado') {
            rows.push({
              description: new Date(el.description),
              title: el.title,
              status: 'error'
            });
          } else {
            rows.push({
              description: new Date(el.description),
              title: el.title
            });
          }
          loadingHistory.value = false;
        }
      });

      rows.sort(function (a, b) {
        return a.description - b.description;
      });

      for (let i = 0; i < rows.length; i += 1) {
        const element = rows[i];
        const fecha = parseDate(element.description); // formatDate(element.description);
        rows[i].description = fecha;
      }
      return rows;
    });

    // * Mensaje aseguradora
    const insuranceMessage = ref('');
    const getInsuranceMessage = (value) => {
      if (value.emailTicket != null) {
        insuranceMessage.value = value.emailTicket.message;
      }
    };

    // * Cancelar ticket
    const openCancelModal = () => {
      Modal.confirm({
        title: () =>
          '¿Estás seguro que deseas cancelar el ticket de modificación?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          cancelTicket();
        },
        onCancel() {}
      });
    };

    const loading = ref(false);
    const cancelTicket = async () => {
      loading.value = true;
      try {
        // Hago la request hacia la base de datos
        const response = await store.dispatch(
          CANCEL_MODIFICATION_INDIVIDUAL,
          modificationId
        );

        // Actualizo nuevamente el stepper para que se coloque automaticamente
        await stepperData(modificationId);
        // Actualizo la data
        getData(modificationId);

        // Agrego una row más al historial
        records.push({
          title: 'Cancelado',
          description: response.data.createdAt
        });
        if (headerStateData.text == 'cancelado') {
          cancel_ticket.value = false;
        }
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    };

    // * Ejecutar ticket
    const openExecuteModal = () => {
      Modal.confirm({
        title: () =>
          '¿Estás seguro que deseas ejecutar el ticket de modificación?',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: () => 'Sí',
        cancelText: () => 'No',
        onOk() {
          execute();
        },
        onCancel() {}
      });
    };

    const execute = async () => {
      loading.value = true;
      try {
        await store.dispatch(
          POST_EXECUTE_MODIFICATION_INDIVIDUAL,
          modificationId
        );

        // Actualizo nuevamente el stepper para que se coloque automaticamente
        await stepperData(modificationId);

        // Actualizo la data
        getData(modificationId);
      } catch (error) {
        console.log(error);
      }
      loading.value = false;
    };

    // * Obtener la data principal al cargar la página
    const getData = async (id) => {
      try {
        // Dejo el historila vacio para no tener ningun problema futuro
        records.length = 0;

        // Obtengo data del ticket
        await getTicketData(id);

        // OBtengo mensaje de aseguradora
        await getInsuranceMessage(ticket);

        await getTicketOptionalFiles();

        // Obtengo los comentarios asociados al ticket
        await getCommentsFromTicket(id);

        // Obtengo el registro de archivos enviados por el ticket
        await getFilesRecordsFromTicket(id);

        // Obtengo data para el stepper
        await stepperData(id);
      } catch (error) {
        console.log('error', error);
      }
    };
    getData(modificationId);
    // * Crear data para la tabla principal
    const dataToTable = computed(() => {
      return [
        {
          key: 'Nombre',
          value:
            ticket?.employee?.fullname ||
            (ticket?.employee?.firstName && ticket?.employee?.firstSurname
              ? `${ticket.employee.firstName} ${ticket.employee.firstSurname}`
              : '')
        },
        {
          key: 'RUT',
          value: ticket.employee
            ? rutHelper.formatRut(ticket.employee.rut)
            : 'No hay datos'
        },
        {
          key: 'Empresa',
          value: ticket.company ? ticket.company.businessName : 'No hay datos'
        },
        {
          key: 'Aseguradora',
          value: ticket.insurance ? ticket.insurance : 'No hay datos'
        }
      ];
    });

    return {
      ticket,
      finishAlta,
      comments,
      fileRecords,
      dataToTable,
      finalState,
      finalDates,
      stepperRef,
      getNewCommment,
      commentsOrdered,
      modificationId,
      insuranceMessage,
      routes,
      headerStateData,
      cancelTicket,
      execute,
      orderedRecords,
      openCancelModal,
      openExecuteModal,
      cancel_ticket,
      userRole,
      ticketLastStateId,
      loading,
      finishStep,
      loadTicket,
      ticketStateId,
      loadingHistory,
      ticketOptionalFiles,
      loadingOptionalFiles,
      getTicketOptionalFiles
    };
  }
};
</script>
